var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loading"}},[_c('div',{attrs:{"id":"loading"}},[_c('progress-bar',{attrs:{"progress":_vm.loading.progress}}),_c('animated-number',{attrs:{"number":_vm.loading.progress * 100,"time":200,"digits":0}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }